module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "box center"
  }, [(!_vm.signedin && !_vm.wasSignedIn) ? _c('Loading', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "show": true,
      "static": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.signedin && !_vm.wasSignedIn) ? _c('img', {
    staticStyle: {
      "height": "40px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.signedin && !_vm.error) ? _c('p', [_vm._v("Din bokning behandlas. Om du stannar kvar på den här sidan kommer du snart att automatiskt bli inloggad.")]) : _vm._e(), _vm._v(" "), (_vm.signedin && _vm.wasSignedIn) ? _c('p', [_vm._v("Du kan strax hitta din bokning under "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.myPage
    }
  }, [_vm._v("Mina sidor")]), _vm._v(".")]) : _vm._e(), _vm._v(" "), (_vm.signedin && !_vm.wasSignedIn) ? _c('p', [_vm._v("Du är nu inloggad och kan strax hitta din bokning under "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.myPage
    }
  }, [_vm._v("Mina sidor")]), _vm._v(".")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.signedin) ? _c('CheckUpdateAddress') : _vm._e(), _vm._v(" "), _c('div', {
    ref: "klarnaCode",
    staticStyle: {
      "overflow-x": "hidden"
    },
    attrs: {
      "id": "klarna-checkout-container"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbc432da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/KlarnaCheckoutConfirmation.vue
// module id = 1018
// module chunks = 0